import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
// import variables from "../../styles/includes/variables.scss";
import * as client from "../../services/client";
import Table, { Hidden } from "../../components/Table";
import { Link } from "react-router-dom";
import { PATHS } from "../../common/constants";
import Actions from "../../components/Actions";
import Search from "../../components/Search";
import Empty from "../../components/Empty";
import Loader from '../../components/Loader';
import { variables } from '../../Tenants';


class ContactProperties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      properties: [],
      propertiesData: [],
      loading: false,
    };
  }
  componentDidMount() {
    const { contact } = this.props;
    this.getHomeownerProperty(contact.id);
  }
  getHomeownerProperty(id) {
    this.setState({
      loading: true,

    })
    client.getPropertyByHomeownerId(id).then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responseJson) => {
          const data = responseJson.map((item) => {
            return {
              ...item,
              isPrimaryContact: item.primaryContact !== null ? "Yes" : "No",
            };
          });
          this.setState({
            properties: data,
            propertiesData: data,
            loading: false,
          });
          // }
        });
      }
    });
  }
  searchProperties(value) {
    const data = this.state.properties.filter((item) => {
      const name = item.name.toLowerCase().includes(value.toLowerCase());
      const addressLine1 = item.addressLine1
        .toLowerCase()
        .includes(value.toLowerCase());
      const number = item.number.toLowerCase().includes(value.toLowerCase());
      const isPrimaryContact = item.isPrimaryContact
        .toLowerCase()
        .includes(value.toLowerCase());
      return name || addressLine1 || number || isPrimaryContact;
    });
    this.setState({
      propertiesData: data,
    });
  }

  render() {
    
    return (
      <div>
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Properties..."
            onChange={(e) => this.searchProperties(e.target.value.trim())}
          />
        </Actions>
        {this.state.propertiesData.length > 0 ? (
          <Table
            columns={[
              {
                label: "Property",
                accessor: "name",
                sortable: true,
                cell: (data) => (
                  <Link
                    // onClick={()=> {
                    //   onExitPropertyWalkThroughForm()
                    //   onExitEasyWalkThroughForm()
                    // }}
                    to={PATHS.PROPERTIES_VIEW.replace(":id", data.propertyId)}
                    // to={{
                    //   pathname:PATHS.PROPERTIES_VIEW.,
                    //   state:{ data:data}
                    // }}
                  >
                    {data.name}
                  </Link>
                ),
              },
              {
                // xsHide:true,
                label: "Address",
                accessor: "addressLine1",
              },
              {
                center: true,
                xsHide: true,
                label: variables.Suite + "s",
                accessor: "number",
              },
              {
                center: true,
                xsHide: true,
                label: "Primary Contact",
                accessor: "isPrimaryContact",
              },
            ]}
            data={this.state.propertiesData}
          />
        ) : (
      this.state.loading ? <Loader /> :

          <Empty
            direction="ttb"
            headline="No properties yet"
            strapline="All properties you add will be listed here so it’s easier for you to manage."
            searchIsActive={
              this.state.propertiesData.length ? this.state.propertiesData : ""
            }
            cta={""}
            image={
              <img alt="No properties yet" src="/assets/empty/properties.svg" />
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
 
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
    
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContactProperties);
